import { createNewHandbookApi } from '@/api/handbookApi'
import { POSITION_PROPERTY_URL } from '@/api/handbook/position'
import { createHandbookResponseErrors } from '@/utils/error/responseErrors'

const FLATNESS_URL = `${POSITION_PROPERTY_URL}/flatnesses`

const errors = createHandbookResponseErrors('плоскостность', 'плоскостностей')

export const FlatnessApi = createNewHandbookApi(FLATNESS_URL, errors)
